const ROLE_LABELS: Record<string, string> = {
  PROJECT_MANAGER: "Project Manager",
  FOREMAN: "Foreman",
  WORKER: "Worker",
};

/**
 * Formats a role enum (e.g. `PROJECT_MANAGER`) for display as `Project Manager`.
 * Known roles use a curated label; anything else falls back to Title Case of the
 * snake_case value. Returns "" for empty input so callers can supply their own
 * default (e.g. `formatRole(user?.role) || "User"`).
 */
export function formatRole(role?: string | null): string {
  if (!role) return "";
  return (
    ROLE_LABELS[role] ??
    role
      .split("_")
      .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
      .join(" ")
  );
}
